import React from "react";
import StoreMallDirectory from "@material-ui/icons/StoreMallDirectory";

import "./CompanyDetails.scss";
import { Currency } from "../../containers/NewOrderContainer/types";
import StorageIcon from "@material-ui/icons/Storage";

const CompanyDetails = (props: any) => {
  function getCurrency(currencyId: number): string {
    if (props.currencies) {
      const currency = props.currencies.find(
        (c: Currency) => c.id === currencyId
      );
      if (currency) {
        return `${currency.region} - ${currency.name}`;
      }
    }
    return "";
  }

  if (!props.company) {
    return null;
  }
  return (
    <div className="CompanyDetails-container">
      <div className="CompanyDetails-companyDetailsContainer">
        <div className="CompanyDetails-companyDetails">
          <div>
            <b className="CompanyDetails-infoLabel">Name:</b>{" "}
            <b className="CompanyDetails-companyDetailsName CompanyDetails-infoItem">
              {props.company.name}
            </b>
          </div>
        </div>
        <div className="CompanyDetails-companyDetails">
          <div>
            <b className="CompanyDetails-infoLabel">Rate Type:</b>{" "}
            <b className="CompanyDetails-companyRateType CompanyDetails-infoItem">
              {props.company.fxRateType === 0 ? "Live" : "Daily"}
            </b>
          </div>
        </div>
        <div className="CompanyDetails-companyDetails">
          <div>
            <b className="CompanyDetails-infoLabel">
              Rate Card Email Addresses:
            </b>{" "}
            <b className="CompanyDetails-companyRateCardEmailAddresses CompanyDetails-infoItem">
              {props.company.rateCardEmailAddresses &&
              props.company.rateCardEmailAddresses.length > 0
                ? props.company.rateCardEmailAddresses.join(", ")
                : "None"}
            </b>
          </div>
        </div>
        <div className="CompanyDetails-companyDetails">
          <div>
            <b className="CompanyDetails-infoLabel">Order Charge:</b>{" "}
            <b className="CompanyDetails-orderCharge CompanyDetails-infoItem">
              {props.company.orderCharge ? props.company.orderCharge : "0"}
            </b>
          </div>
        </div>
        <div className="CompanyDetails-companyDetails">
          <div>
            <b className="CompanyDetails-infoLabel">Return Charge:</b>{" "}
            <b className="CompanyDetails-returnCharge CompanyDetails-infoItem">
              {props.company.returnCharge ? props.company.returnCharge : "0"}
            </b>
          </div>
        </div>
      </div>

      {props.showBranches && (
        <div className="CompanyDetails-tableContainer">
          <div className="CompanyDetails-infoLabel CompaniesTable-tableTitle">
            Margins/Charges:
          </div>
          <table className="MarginsTable-container">
            <thead className="MarginsTable--headPanel">
              <tr className="MarginsTable--headPanelRow">
                <th>Buy/Sell</th>
                <th>Currency</th>
                <th>Margin (%)</th>
                <th>Charge (£)</th>
                <th>Charge (%)</th>
                <th>Min (£)</th>
                <th>Settlement</th>
              </tr>
            </thead>
            <tbody>
              {props.company.marginsAndCharges &&
                props.company.marginsAndCharges.map((data: any) => (
                  <tr className="MarginsTable--row">
                    <td>{data.direction === 0 ? "Sell" : "Buy"}</td>
                    <td>
                      {data.currencyId === null
                        ? "All currencies"
                        : getCurrency(data.currencyId)}
                    </td>
                    <td>
                      {data.marginPercent
                        ? `${data.marginPercent.toLocaleString(
                            navigator.language,
                            {
                              minimumFractionDigits: 2
                            }
                          )}%`
                        : ``}
                    </td>
                    <td>
                      {data.chargeAbsolute
                        ? `£${data.chargeAbsolute.toLocaleString(
                            navigator.language,
                            {
                              minimumFractionDigits: 2
                            }
                          )}`
                        : ``}
                    </td>
                    <td>
                      {data.chargePercent
                        ? `${data.chargePercent.toLocaleString(
                            navigator.language,
                            {
                              minimumFractionDigits: 2
                            }
                          )}%`
                        : ``}
                    </td>
                    <td>
                      {data.minimumCharge
                        ? `£${data.minimumCharge.toLocaleString(
                            navigator.language,
                            {
                              minimumFractionDigits: 2
                            }
                          )}`
                        : ``}
                    </td>
                    <td>
                      {data.settlementSource === 0 ? <>UK-Pound</> : <>FCA</>}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {!props.company.marginsAndCharges ||
          props.company.marginsAndCharges.length === 0 ? (
            <div className="MarginsTable--noDataContainer">
              <StorageIcon className="MarginsTable--noDataIcon" />
              <p className="MarginsTable--noDataText">
                There are currently no margins to display.
              </p>
            </div>
          ) : (
            <></>
          )}
        </div>
      )}

      {props.showBranches && (
        <div className="CompanyDetails-tableContainer">
          <div className="CompanyDetails-infoLabel CompaniesTable-tableTitle">
            Branches:
          </div>
          <table className="CompaniesTable-container CompanyDetails-branches">
            <thead className="CompaniesTable--headPanel">
              <tr className="CompaniesTable--headPanelRow">
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              {props.company.branches &&
                props.company.branches.map((company: any) => (
                  <>
                    <tr
                      className="CompaniesTable--row"
                      onClick={() => props.setShowBranchDetails(true)}
                    >
                      <td className="CompaniesTable-Name">{company.name}</td>
                    </tr>
                  </>
                ))}
            </tbody>
          </table>

          {props.company &&
          props.company.branches &&
          props.company.branches.length === 0 ? (
            <div className="CompaniesTable--noDataContainer">
              <StoreMallDirectory className="CompaniesTable--noDataIcon" />
              <p className="CompaniesTable--noDataText">
                There are currently no branches to display for this company.
              </p>
            </div>
          ) : (
            <></>
          )}
        </div>
      )}
    </div>
  );
};

export default CompanyDetails;
